module.exports = __webpack_public_path__ + "img/red-i.8dc72b4f.svg";